import React from "react";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { Button, Popconfirm } from "antd";

import { DeleteEventIcon, EditIcon } from "../../../../../resource/icons";
import { cancelVoting, stopVoting } from "../../../store/thunks/voting-states";
import SelectedAddresses from "../../../components/form/selected-addresses/selected-addresses";
import selectedAddressesToTree from "../../../utils/selectedAddressesToTree";
import {
	getVotingFile,
	getVotingFilePreview,
} from "../../../store/thunks/get-file";
import Attachment from "../../../components/attachments/attachment";
import PlayButton from "./play-button";
import stateIcon from "../../../components/state-icon/state-icon";
import ButtonSave from "./SaveVoiting/ButtonSave";

const MainInfo = () => {
	const voting = useSelector((store) => store.votingStore.voting);
	const {
		state,
		title,
		text,
		id,
		dateStart,
		dateStop,
		attachments,
		addresses: rawSelectedAddresses,
	} = voting;
	const dispatch = useDispatch();
	const addresses = useSelector(
		(store) => store.votingStore.addresses.addresses
	);
	const selectedAddresses = selectedAddressesToTree(
		rawSelectedAddresses,
		addresses
	);

	return (
		<div className="main-info">
			<div className="state-block">
				<div className="state">
					<span style={{ fontSize: "18px", marginRight: "10px" }}>
						{stateIcon[state?.id]}
					</span>
					<span className="text">
						{state.name === "Активное" ? "Активный" : state.name}
					</span>
				</div>
				<div>
				  <ButtonSave />
				</div>
			</div>
			<div className="title">{title}</div>
			<div className="text">{text}</div>
			<div className="period">
				<span className="text">Период</span>
				<br />
				<span className="text">
					{moment(dateStart).format("DD.MM.YY HH:mm")} -{" "}
					{moment(dateStop).format("DD.MM.YY  HH:mm")}
				</span>

				<div className="attachments">
					{attachments.length > 0 &&
						attachments.map((attachment) => {
							return (
								<Attachment
									getFile={() => {
										return getVotingFile(id, attachment.fileName);
									}}
									uploadedFileText={attachment.name}
									key={attachment.id}
									loadPreview={() => {
										return getVotingFilePreview(id, attachment.fileName);
									}}
								/>
							);
						})}
				</div>
				{addresses.length > 0 && (
					<SelectedAddresses selectedAddresses={selectedAddresses} />
				)}
			</div>
			<div className="buttons">
				{state?.id === 1 && (
					<Link to={`/Voting/${id}/editing`} className="edit button">
						<Button className="edit button">
							<EditIcon className="edit-icon" />
							<span>Редактировать</span>
						</Button>
					</Link>
				)}
				<PlayButton selectedAddresses={selectedAddresses} />
				{voting?.state?.id === 2 && (
					<Popconfirm
						placement="top"
						title={"Завершить опрос?"}
						onConfirm={() => dispatch(stopVoting(voting))}
						okText="Да"
						cancelText="Нет"
					>
						<Button className="stop button">
							<DeleteEventIcon />
							<span>Завершить</span>
						</Button>
					</Popconfirm>
				)}
				{voting?.state?.id === 4 && (
					<Popconfirm
						placement="top"
						title={`Отменить запуск опроса ${moment(voting.dateStart).format(
							"DD.MM.YYYY"
						)}?`}
						onConfirm={() => dispatch(cancelVoting(voting))}
						okText="Да"
						cancelText="Нет"
					>
						<Button className="cancel button">
							<DeleteEventIcon />
							<span>Отменить запуск</span>
						</Button>
					</Popconfirm>
				)}
			</div>
		</div>
	);
};

export default MainInfo;
